import React from 'react';

type SmallAvatarProps = {
  imageUrl: string;
  theme?: 'primary' | 'secondary' | 'none';
  variant?: 'normal' | 'tiny';
};

const themeBorderClasses = {
  primary: 'border-primary ',
  secondary: 'border-secondary ',
  none: '',
};

const SmallAvatar: React.FC<SmallAvatarProps> = ({ imageUrl, theme, variant = 'normal' }) => {
  const borderClass = theme ? themeBorderClasses[theme] : '';

  return (
    <div className={`inline-block rounded-full overflow-hidden ${borderClass} ${theme ? 'border-2' : ''}`}>
      {variant === 'normal' ? (
        <img src={imageUrl} alt="Avatar" className="w-10 h-10 object-cover" />
      ) : (
        <img src={imageUrl} alt="Avatar" className="w-6 h-6 object-cover" />
      )}
    </div>
  );
};

export default SmallAvatar;